export const SURVEY_SCREENING = 1;
export const SURVEY_SCREENING_FAILED_RESET_QUES = 2; //not using in start
export const SURVEY_SCREENER_PASSED_CLIENT_REDIRECT = 3;
export const SURVEY_SCREENER_FAILED_SUPPLIER_REDIRECT = 4;





